import React from 'react';

const GrainOverlay: React.FC = () => (
  <div
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      pointerEvents: 'none',
      zIndex: 9999,
    }}
  >
    <svg width="100%" height="100%" style={{ display: 'block' }}>
      <filter id="grain-filter">
        <feTurbulence
          type="fractalNoise"
          baseFrequency="0.65"
          numOctaves="3"
          stitchTiles="stitch"
        />
      </filter>
      <rect
        width="100%"
        height="100%"
        filter="url(#grain-filter)"
        opacity="0.035"
      />
    </svg>
  </div>
);

export default GrainOverlay;
